<script>
import ImageLoader from "@js/components/Loaders/ImageLoader.vue";
import {Link} from "@inertiajs/vue3";
import NumberFormatComponent from "@js/components/Formatter/NumberFormatComponent.vue";
import {Swiper, SwiperSlide} from "swiper/vue";
import "swiper/css";
import 'swiper/css/pagination'
import {Pagination} from 'swiper/modules'
import default_img from "@img/defaults/product-not-found.webp";

export default {
    name: "PopularCollectionCard",
    props: {
        collection: {
            required: true,
        }
    },
    components: {
        NumberFormatComponent,
        Link,
        ImageLoader,
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            swiper: null,
        }
    },
    methods: {
        setSwiper(swiperInstance) {
            this.swiper = swiperInstance;
        },
    },
    setup() {
        return {
            modules: [Pagination],
            default_img
        }
    }
}
</script>

<template>
    <Link :href="route('showCollection', {slug:collection.slug})" class="relative">
        <div
            class="h-full flex flex-col bg-white shadow border border-gray-200 md:hover:border-baseColor max-md:active:border-baseColor rounded-xl">
            <div class="relative overflow-hidden rounded-t-xl flex flex-col z-1 shadow-sm bg-white">
                <div class="absolute right-0" v-if="collection.bestseller">
                    <div class="font-bold text-[11px] text-white px-3 py-0.5 rounded-bl-md bg-[#c52314] leading-5">
                        ХИТ ПРОДАЖ
                    </div>
                </div>
                <div class="block w-full h-[175px]">
                    <Swiper v-if="collection.images && collection.images.length"
                            :slides-per-view="1"
                            :space-between="0"
                            @swiper="setSwiper"
                            :modules="modules"
                            :pagination="{ clickable: true }"
                            :loop="collection.images.length > 1"
                            :autoplay="{ delay: 5000, disableOnInteraction: true }"
                            class="pagination-base long_bullet bg-transparent h-full">
                        <SwiperSlide v-for="(image, key) in collection.images">
                            <ImageLoader :title="'Изображение коллекции ' + key"
                                         :src="image"
                                         imgClasses="w-full h-full object-cover"/>
                        </SwiperSlide>
                    </Swiper>
                    <ImageLoader v-else
                                 title="Изображение не найдено" :src="default_img"
                                 imgClasses="w-full h-full object-cover"/>
                </div>
            </div>
            <div class="p-4 flex-1 flex flex-col">
                <!-- Описание -->
                <div class="font-medium text-base cursor-pointer mb-2 md:hover:text-navHoverColor transition">
                    {{ collection.title }}
                </div>
                <div class="flex flex-col gap-2 mb-5">
                    <div class="flex items-center gap-2 text-sm leading-tight">
                        <p v-if="collection.brand">{{ collection.brand.title }}</p>
                        <img v-if="collection.brand.country_code"
                             :src="'/assets/flags/' + collection.brand.country_code + '.svg'"
                             title="flag" alt="flag"
                             class="h-3 w-4 rounded object-cover"/>
                    </div>
                    <div v-if="collection.colors"
                         class="flex flex-wrap gap-2">
                        <template v-for="color in collection.colors">
                            <div class="flex items-center justify-center w-4 h-4 rounded-full border border-gray-400"
                                 :style="{'background-color': color}">
                                <div
                                    class="w-1.5 h-1.5 rounded-full bg-white border border-gray-400"></div>
                            </div>
                        </template>
                    </div>
                    <div v-if="collection.rooms"
                         class="leading-tight">
                        <span v-for="room in collection.rooms"
                              class="text-xs">
                            <span class="text-nowrap">
                            {{ room }}
                            </span>
                            <span>, </span>
                        </span>
                    </div>
                </div>
                <div class="flex flex-col gap-3 mt-auto">
                    <div class="text-nowrap text-sm leading-tight">
                        Цена от:
                        <template v-if="collection.min_price">
                            <NumberFormatComponent :number="collection.min_price"
                                                   class="text-[20px] font-semibold"/>
                            руб./м2
                        </template>
                        <span v-else class="text-[20px] font-semibold">
                            Договорная
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </Link>
</template>

<style scoped lang="scss">

</style>
